<template>
  <div class="table-list">
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column
        type="index"
        :index="indexMethod"
        align="center"
        width="50"
      ></el-table-column>
      <el-table-column :label="$t('VehicleManagement.materialName')" align="center">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.materialName"></el-input>
        </template>
      </el-table-column>
      <el-table-column :label="$t('VehicleManagement.unitPrice')" align="center">
        <template slot-scope="scope">
          <el-input
            @change="changTotal(scope.$index, scope.row)"
            size="small"
            v-model="scope.row.unitPrice"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column align="center" :label="$t('common.number')">
        <template slot-scope="scope">
          <el-input
            @change="changTotal(scope.$index, scope.row)"
            size="small"
            v-model="scope.row.number"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column align="center" :label="$t('VehicleManagement.amount')">
        <template slot-scope="scope">
          <el-input
            disabled
            size="small"
            v-model="scope.row.cost"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column align="center" width="50" :label="$t('common.btn.operate')">
        <template slot-scope="scope">
          <i
            style="color: #6078fd"
            @click="handleDelete(scope.$index, scope.row)"
            class="el-icon-delete"
          ></i>
        </template>
      </el-table-column>
    </el-table>
    <el-button @click="addCol" type="text" size="small" icon="el-icon-plus"
      >{{$t('VehicleManagement.btn.addNewLine')}}</el-button
    >
  </div>
</template>   
<script>
export default {
  data() {
    return {
      tableData: [],
    };
  },
  computed: {
    peijianTotal() {
      let price = 0;
      this.tableData.map((item, index) => {
        price = Number(price) + Number(item.cost);
      });
      return price;
    },
  },
  watch: {
    peijianTotal(val) {
      this.$emit("computedPrice", val);
    },
  },
  methods: {
    addCol() {
      let obj = {
        materialName: null,
        unitPrice: null,
        number: null,
        cost: null,
      };
      this.tableData.push(obj);
    },
    changTotal(index, row) {
      this.tableData[index].cost = row.unitPrice * row.number;
    },
    handleDelete(index, row) {
      this.tableData.splice(index, 1);
    },
    indexMethod(index) {
      return index + 1;
    },
  },
};
</script>

<style lang="less" scoped>
.table-list {
  /deep/.el-button {
    background-color: transparent;
    border: none;
    border-radius: 0;
  }

  /deep/.el-table--border {
    border-color: #ddd;
  }

  /deep/.el-table th {
    font-size: 14px;
    color: #333;
    background-color: #e8e8e8;
    padding: 0;
    height: 40px;
  }

  /deep/.el-table td {
    font-size: 13px;
    color: #333;
    height: 35px;
    padding: 0;
  }

  /deep/.el-table--border th,
  /deep/.el-table--border td {
    border-bottom-color: #ddd;
    border-right-color: #ddd;
  }

  /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: #efefef;
  }

  /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
  /deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #5f77fd;
    border-color: #5f77fd;
  }

  /deep/.el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #5f77fd;
  }

  /deep/.el-table .cell,
  .el-table th div {
    padding: 0;
  }

  /deep/.el-tag {
    background-color: #5f77fd;
    font-size: 13px;
    color: #fff;
    width: 60px;
    height: 24px;
    line-height: 24px;
    border: none;
  }

  /deep/.iconicon-chakanxq:before {
    color: #5f77fd;
  }
}
</style>